import { render, staticRenderFns } from "./SynastryGift.vue?vue&type=template&id=277c4579&scoped=true&"
import script from "./SynastryGift.vue?vue&type=script&lang=js&"
export * from "./SynastryGift.vue?vue&type=script&lang=js&"
import style0 from "./SynastryGift.vue?vue&type=style&index=0&id=277c4579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c4579",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277c4579')) {
      api.createRecord('277c4579', component.options)
    } else {
      api.reload('277c4579', component.options)
    }
    module.hot.accept("./SynastryGift.vue?vue&type=template&id=277c4579&scoped=true&", function () {
      api.rerender('277c4579', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/雙人合盤/SynastryGift.vue"
export default component.exports